import { render, staticRenderFns } from "./post_price.vue?vue&type=template&id=7f404854&scoped=true&"
import script from "./post_price.vue?vue&type=script&lang=js&"
export * from "./post_price.vue?vue&type=script&lang=js&"
import style0 from "./post_price.vue?vue&type=style&index=0&id=7f404854&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f404854",
  null
  
)

export default component.exports